import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabhire() {



  const cardData =
  {
    keyword: 'Pune to Goa Cab Hire',
    heading: 'Sai Trupti Cabs: Pune to Goa Cab Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Goa cab hire services, designed to make your out-station journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Goa. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Goa convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Goa with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach is one of Goa’s best-known coastal destinations, stretching along golden sands and offering a lively blend of sun, sea and celebration. Located in North Goa, its shoreline is framed by colourful beach shacks, vibrant water-sports operators and the hum of international travellers. As the waves wash in, visitors enjoy parasailing, banana rides and jet-skis, followed by chilled drinks at sunset. Street food vendors serve delicious Goan snacks while the late-night bazaars add an extra layer of excitement. Calangute captures the spirit of Goa — fun-filled, carefree and cosmopolitan."
  },
  {
    "title": "Basilica of Bom Jesus, Old Goa",
    "description": "The Basilica of Bom Jesus in Old Goa is a UNESCO world heritage site and a jewel of Portuguese-Indian architecture. Built in the early 1600s, it houses the sacred tomb of Saint Francis Xavier and features baroque façades, ornate interiors and paintings that reflect centuries of faith. Pilgrims and sightseers alike walk its quiet cloisters and wonder at its gilded altars. Set in shaded gardens and near other colonial churches, the basilica offers a serene contrast to Goa’s beaches. Its timeless presence connects visitors to a heritage of devotion, art and history."
  },
  {
    "title": "Dudhsagar Falls",
    "description": "Tucked away in the dense forests of the Western Ghats, Dudhsagar Falls is one of India’s tallest and most spectacular waterfalls, cascading from a height of over 300 metres. A dramatic rupee-white plume of water plunges into a green valley, surrounded by trees and mist-filled air. Visitors access it via a forest jeep ride or a trek along railway tracks for the adventurous. After the monsoon the falls roar in full force, creating a thunderous yet beautiful spectacle. It is nature at its wildest and most majestic — truly a gem of Goa’s inner landscape."
  },
  {
    "title": "Anjuna Beach & Flea Market",
    "description": "Anjuna Beach is famed for its easy-going vibe, rocky headlands, and sundowners overlooking the Arabian Sea. By day it’s a beach where you can unwind, sunbathe, swim and enjoy shacks; by evening it transforms as the iconic Anjuna Flea Market opens. Stalls of Bohemian fashion, jewellery, art and souvenirs line the sandy stretch, while music floats in from nearby cafés. The beach’s laid-back energy, world-traveller crowd and vibrant sunset scenes make Anjuna a must-visit for those wanting more than just a beach—an experience of community, style and escape."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is a picturesque bay of soft white sand, turquoise waters and gently swaying palms — designed for calm, relaxation and scenic beauty. In a comparatively quieter setting, it offers kayaking, dolphin-spotting boat rides, and rustic beach huts where travellers wake to ocean breezes. The crescent shape of the bay gives perfect views of sunrise and sunset, and the easy rhythm of life here makes it ideal for couples and families. With fewer party crowds and more natural charm, Palolem shows another side of Goa — tranquil, soulful and subtly luxurious."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada stands proudly on a cliff above Sinquerim Beach, overlooking the Arabian Sea and serving as a vivid reminder of Goa’s colonial maritime past. Built by the Portuguese in the 17th century, the fort features ramparts, a lighthouse and cannons pointing out to sea. The sea breeze, panoramic view and the ruins create a dramatic atmosphere — particularly at golden hour. Visiting Fort Aguada combines history, architecture and the pleasure of a scenic stroll. It is a heritage landmark that anchors the fun of Goa’s beaches with deeper cultural roots."
  },
  {
    "title": "Ashwem & Morjim Beaches",
    "description": "Ashwem and Morjim beaches in North Goa offer a more relaxed, boutique-style coastal experience — quieter sands, upscale beach cafés and a touch of nature’s tranquility. These stretches are favoured by couples and travellers seeking calm among palms, hammocks and slow rhythms. You can wander barefoot on the sand, sip fresh kokum drinks and witness sea turtles (in season) nesting along the shore. The laid-back elegance of Ashwem & Morjim reflects a side of Goa that pairs luxury with simplicity, and peace with sea breeze."
  },
  {
    "title": "Spice Plantations & Backwater Cruise",
    "description": "Goa’s spice plantations and back-water cruises offer a lush escape into its interior landscapes — where red soil, coconut groves and cardamom scent fill the air. Travellers visit historic estates to see pepper vines, cinnamon trees and get a taste of Goan-Catholic-plantation culture over a traditional meal. Later a serene cruise through Goan backwaters or the Mandovi River reveals mangroves, birdlife and the gentle rhythm of rural life. This side of Goa balances beach fun with earth-bound calm, inviting you to slow down and savour the natural and cultural richness."
  },
  {
    "title": "Chapora Fort & Vagator Beach",
    "description": "Chapora Fort stands above Vagator Beach offering one of the most photogenic vantage points in Goa — sweeping views of sea, cliffs and shoreline. The trek up to the fort brings you through old ruins and scenic terrain, arriving at a platform where you can watch waves crashing beneath. Vagator Beach below is lively yet more scenic than many north-beach resorts. The combination of fort-viewpoint, sea-scapes and sunset ambience makes this a destination for style-seekers, travellers looking for the dramatic view and beach lovers alike. Goa’s edgy charm lives in places like Chapora and Vagator."
  },
  {
    "title": "Fontainhas Latin Quarter & Panaji Old Town",
    "description": "The Fontainhas Latin Quarter in Panaji is a charming heritage precinct where narrow lanes, colourful Portuguese houses, pastel facades and peppy cafés converge. Wandering through the alleyways you’ll find art galleries, local bakeries and colonial-era balconies overlooking stone-paved streets. Panaji’s riverside promenade, the Basilica of Our Lady of the Immaculate Conception and the mix of Goan-Portuguese culture make this a perfect urban contrast to the coast. Fontainhas allows you to slow down, stroll, explore architecture and feel Goa’s layered identity — historic, textured and elegant."
  }
],



"services": [
  {
    "name": "Pune to Goa Cab Hire",
    "description": "Reliable cab service from Pune to Goa with professional drivers, luggage assistance, and AC/non-AC vehicle options. Perfect for long-distance trips, group travel, family vacations, and corporate outings. Offers flexible pickup and drop points, transparent fares, and a safe, comfortable journey throughout."
  },
  {
    "name": "Pune to Goa Taxi Service",
    "description": "Premium taxi service from Pune to Goa featuring well-maintained vehicles, experienced drivers, luggage support, and AC/non-AC options. Ideal for sightseeing trips, leisure travel, and business travel, providing hassle-free online booking and a comfortable long-distance ride with timely arrivals."
  },
  {
    "name": "Pune to Goa Car Hire",
    "description": "Hire cars from Pune to Goa including sedans, SUVs, Innova, and Ertiga with professional drivers, luggage assistance, AC/non-AC options, and flexible schedules. Ensures a smooth and convenient travel experience for families, friends, and corporate clients with safe and reliable transportation."
  },
  {
    "name": "Pune to Goa AC Cab",
    "description": "Comfortable AC cab service from Pune to Goa with professional drivers, luggage assistance, and flexible pickup and drop locations. Perfect for family trips, corporate travel, and long-distance journeys, offering a cool, relaxing ride and punctual service throughout the journey."
  },
  {
    "name": "Pune to Goa Non AC Cab",
    "description": "Budget-friendly non-AC cab service from Pune to Goa with reliable vehicles, professional drivers, luggage support, and flexible schedules. Ideal for travelers seeking economical yet safe and convenient outstation travel with transparent fares."
  },
  {
    "name": "Luxury Cab Pune to Goa",
    "description": "Premium luxury cab service from Pune to Goa featuring top-class vehicles, AC service, professional chauffeurs, luggage assistance, and timely pickups. Ideal for weddings, VIP travel, and corporate trips, ensuring a luxurious, comfortable, and hassle-free journey across long distances."
  },
  {
    "name": "Pune to Goa Innova Cab",
    "description": "Spacious Innova cab from Pune to Goa accommodating 6-7 passengers, with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Perfect for family trips, group travel, and corporate outings requiring comfort, space, and reliability."
  },
  {
    "name": "Pune to Goa Ertiga Cab",
    "description": "Comfortable Ertiga cab service from Pune to Goa with AC/non-AC options, professional drivers, luggage assistance, and flexible pickup/drop locations. Ideal for small families, group outings, and leisure trips, providing a safe, reliable, and pleasant long-distance travel experience."
  },
  {
    "name": "Affordable Pune to Goa Cab",
    "description": "Budget-friendly cab service from Pune to Goa offering AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and transparent fares. Perfect for cost-conscious travelers seeking safe, comfortable, and dependable outstation transportation."
  },
  {
    "name": "Pune to Goa Outstation Cab",
    "description": "Outstation cab service from Pune to Goa with AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and secure online booking. Suitable for weekend trips, leisure travel, and long-distance journeys, providing comfort, safety, and punctuality."
  },
  {
    "name": "Pune to Goa One Way Cab",
    "description": "Convenient one-way cab service from Pune to Goa with AC/non-AC options, professional drivers, luggage support, and transparent fares. Perfect for travelers requiring a one-way drop without worrying about return transportation or extra charges."
  },
  {
    "name": "Pune to Goa Drop Cab",
    "description": "Drop cab service from Pune to Goa featuring AC/non-AC vehicles, professional drivers, luggage assistance, and flexible scheduling. Ensures safe, comfortable, and timely travel to your destination with clear pricing and hassle-free booking."
  },
  {
    "name": "Pune to Goa Corporate Cab",
    "description": "Corporate cab service from Pune to Goa with AC/non-AC vehicles, professional chauffeurs, luggage support, flexible pickup/drop schedules, and online booking. Perfect for business trips, corporate events, and client travel, ensuring comfort, punctuality, and reliability throughout the journey."
  },
  {
    "name": "Pune to Goa Wedding Cab",
    "description": "Premium wedding cab service from Pune to Goa featuring luxurious vehicles, AC/non-AC options, professional drivers, luggage assistance, and timely pickups. Ideal for weddings, transporting family, guests, and VIPs safely, comfortably, and in style."
  },
  {
    "name": "Pune to Goa Online Booking",
    "description": "Book your Pune to Goa cab online instantly with secure payments, multiple AC/non-AC vehicle options, professional drivers, luggage support, and flexible pickup/drop points. Convenient for planning trips in advance or on short notice, ensuring complete transparency and peace of mind."
  }
],
"tableData": [
  ["Pune to Goa Cab Hire", "Pune to Goa Taxi Service"],
  ["Pune to Goa Car Hire", "Pune to Goa AC Cab"],
  ["Pune to Goa Non AC Cab", "Luxury Cab Pune to Goa"],
  ["Pune to Goa Innova Cab", "Pune to Goa Ertiga Cab"],
  ["Affordable Pune to Goa Cab", "Pune to Goa Outstation Cab"],
  ["Pune to Goa One Way Cab", "Pune to Goa Drop Cab"],
  ["Pune to Goa Corporate Cab", "Pune to Goa Wedding Cab"],
  ["Pune to Goa Online Booking", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Cab Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Goa — perfect for leisure trips, beach vacations, and long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Goa cabs, starting at affordable rates depending on the vehicle type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for your Goa trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Goa route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at any location in Goa, including beaches, hotels, resorts, or city centers."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability for the long drive from Pune to Goa."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Goa cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]


















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Goa cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Goa cab hire services for one-way, round trips, family, and group travel.',
  },
  {
    question: 'How can I hire a cab from Pune to Goa with Sai Trupti Cabs?',
    answer: 'You can easily book a cab from Pune to Goa through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available for Pune to Goa travel?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to meet your travel needs, group size, and budget for long-distance trips.',
  },
  {
    question: 'Are the drivers experienced for Pune to Goa long-distance trips?',
    answer: 'Yes, all our drivers are professional, courteous, and highly experienced in long-distance routes, ensuring a safe and comfortable journey to Goa.',
  },
  {
    question: 'Can I hire a cab from Pune to Goa for leisure or corporate travel?',
    answer: 'Certainly. Our Pune to Goa cab hire service caters to leisure trips, corporate travel, family outings, and group tours.',
  },
  {
    question: 'Is the Pune to Goa cab hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab hire services from Pune to Goa for flexible and convenient travel scheduling.',
  },
  {
    question: 'What are the Pune to Goa cab fares?',
    answer: 'Our Pune to Goa cab fares start from approximately ₹6,500 for sedans and ₹8,000–₹10,000 for SUVs and larger vehicles, depending on the vehicle type and duration of travel.',
  },
  {
    question: 'What payment methods are accepted for Pune to Goa cab hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for secure and hassle-free bookings.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Goa cabs?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety standards to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Pune to Goa cab trip?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Goa cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Desai',
    feedback: 'I hired a cab from Pune to Goa with Sai Trupti Cabs. The ride was smooth, the vehicle was comfortable, and the driver was professional and courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Kulkarni',
    feedback: 'Excellent service for Pune to Goa cab hire. Sai Trupti Cabs made our trip easy and hassle-free with a punctual pickup and safe journey.',
    rating: 5,
  },
];
























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-to-goa-cab.jpg",
  "description": "Book reliable cab services from Pune to Goa. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-goa-cab-hire"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Goa Cab Hire | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cab services from Pune to Goa. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs for one-way trips, drop services, corporate travel, weddings, or family trips. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Goa Cab Hire, Pune to Goa Taxi Service, Pune to Goa Car Hire, Pune to Goa AC Cab, Pune to Goa Non AC Cab, Luxury Cab Pune to Goa, Pune to Goa Innova Cab, Pune to Goa Ertiga Cab, Affordable Pune to Goa Cab, Pune to Goa Outstation Cab, Pune to Goa One Way Cab, Pune to Goa Drop Cab, Pune to Goa Corporate Cab, Pune to Goa Wedding Cab, Pune to Goa Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabhire;